import { __ } from '@wordpress/i18n';
import {InspectorControls} from '@wordpress/block-editor';
import {VayuBlocksAdvancePanel} from '@vayu-blocks/advance-panel';
import Layout from './layout.js';
import Style from './style.js';
import {VayuBlocksHeaderTab, usePanelSettings} from '@vayu-blocks';

const panelKeys = [
	'slide-image',
	'slide-icon',
	'slide-scrollbar',

	'slide-child',
	'slide-connector',
];

const initialPanels = {
    slide: 'slide-image',
	overlay: '',
    advanced: '',
};

const panelOptions = [
	{ label: __('Layout', 'vayu-blocks'), value: 'slide', icon: 'icon',},
	{ label: __('Style', 'vayu-blocks'), value: 'overlay', icon: 'diamond',},
	{ label: __('Advanced', 'vayu-blocks'), value: 'advanced', icon: 'colorpalette',},		
];

const PanelSettings = ({ attributes, setAttributes,isSelected,clientId}) => {

	const { tab, setTab, openPanels, onTogglePanel } = usePanelSettings({ clientId, panelKeys, initialPanels, defaultTab: 'slide' });

	const tabComponents = {
		slide: <Layout attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		overlay: <Style attributes={attributes} setAttributes={setAttributes} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
		advanced: <VayuBlocksAdvancePanel attributes={attributes} setAttributes={setAttributes} clientId={clientId} exclude={['Cursor', 'cursorFollower']} openPanels={openPanels} onTogglePanel={onTogglePanel}/>,
	};
	
    return (
		<>
			{isSelected && (
				<InspectorControls>
					<div className='th-block-ins th-button-panel'>

						<VayuBlocksHeaderTab 
							value={ tab }
							options={panelOptions}
							onChange={ setTab }
						/>

						{tabComponents[tab]}

					</div>
				</InspectorControls>  
			)}

    	</>
	);
}

export default PanelSettings;